/**
 * Общая обработка текста вложений для просмотра Markdown.
 * Работает только с байтами: запросы, состояние и отображение остаются у вызывающей стороны.
 */
/** Декодирует исходные байты, не полагаясь на charset ответа файлового хранилища. */
export function decodeAttachmentText(buffer) {
  const bytes = new Uint8Array(buffer);
  if (bytes[0] === 0xff && bytes[1] === 0xfe) return new TextDecoder("utf-16le").decode(buffer);
  if (bytes[0] === 0xfe && bytes[1] === 0xff) return new TextDecoder("utf-16be").decode(buffer);
  try {
    return new TextDecoder("utf-8", { fatal: true }).decode(buffer);
  } catch {
    return new TextDecoder("windows-1251").decode(buffer);
  }
}
